module.exports = __webpack_public_path__ + "img/AIjl.c0480d6e.png";